import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MainLayout from 'layout/MainLayout';

// login option 3 routing
const Withdraw = Loadable(
    lazy(() => import('views/pages/transactions/Withdraw'))
);
const Deposit = Loadable(
    lazy(() => import('views/pages/transactions/Deposit'))
);
const History = Loadable(
    lazy(() => import('views/pages/transactions/History'))
);

// ==============================|| TRANSACTION ROUTING ||============================== //

const TransactionRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/pages/transaction/withdraw',
            element: <Withdraw />,
        },
        {
            path: '/pages/transaction/deposit',
            element: <Deposit />,
        },
        {
            path: '/pages/transaction/history',
            element: <History />,
        },
    ],
};

export default TransactionRoutes;
